import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "caass-visitee-batch-table",
	templateUrl: "./visitee-batch-table.component.html",
	styleUrls: ["./visitee-batch-table.component.css"],
})
export class VisiteeBatchTableComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {
		this.UpdateFilters();
	}

	ngOnChanges() {
		this.UpdateFilters();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() loading: boolean = false;
	pagerows: any = 5;
	pagefirst: any = 0;
	errorMessage: any = "";

	SelectedStaff: any;
	@Input() lstStaff: any = [];

	//Filter lists
	lstActiveDesc: any = [];
	lstValidStaffDesc: any = [];

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedStaff = val.data;
	}
	onRowUnselect(val) {
		this.SelectedStaff = null;
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	UpdateFilters() {
		this.lstActiveDesc = Array.from(new Set(this.lstStaff.map((item: any) => item.ActiveDesc))).sort();
		this.lstValidStaffDesc = Array.from(new Set(this.lstStaff.map((item: any) => item.ValidStaffDesc))).sort();
	}

	////////////////////////////////////////////
}
